import React from 'react'
import PropTypes from 'prop-types'
import { ListGroup } from 'reactstrap'

import ImportListItem from './ImportListItem'

class ImportList extends React.Component {
    static propTypes = {
        data: PropTypes.arrayOf(PropTypes.object),
        onSelect: PropTypes.func,
        selected: PropTypes.object
    }

    static defaultProps = {
        data: [],
        onSelect: () => {},
        selected: {}
    }

    handleSelect = id => {
        this.props.onSelect(id)
    }

    render() {
        const { data } = this.props
        return (
            <ListGroup className="ao-import-list">
                { data.map((item, index) => (
                    <ImportListItem key={ index } { ...item } onSelect={ this.handleSelect } selected={ this.props.selected && this.props.selected.id === item.id } />
                ))}
            </ListGroup>
        )
    }
}

export default ImportList